import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-global-menu',
  templateUrl: './global-menu.component.html',
  styleUrls: ['./global-menu.component.scss'],
})
export class GlobalMenuComponent {}
